var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseScreen',_vm._b({},'BaseScreen',_vm.screen,false),[_c('Instruction',_vm._b({staticClass:"screen__stretch screen__offset-right"},'Instruction',_vm.instruction,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }